var map = {
	"./Buoy.vue": 5681,
	"./Motorboat.vue": 4226,
	"./Other.vue": 2954,
	"./Sailboat.vue": 3838
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(() => {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 6583;
module.exports = webpackAsyncContext;